import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  Button,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export function ServerError() {
  const { t } = useTranslation();

  function refreshPage() {
    // Refresh the page
    location.reload();
  }

  return (
    <Box>
      <Typography
        variant='h1'
        sx={{
          marginBottom: 4,
        }}
      >
        {t('serverError.title')}
      </Typography>
      <Typography
        sx={{
          marginBottom: 2,
        }}
      >
        {t('serverError.content')}
      </Typography>
      <Typography
        sx={{
          marginBottom: 1,
        }}
      >
        {t('serverError.guide.title')}
      </Typography>
      <List
        component='ul'
        sx={{ paddingLeft: 1, marginBottom: 6 }}
        disablePadding
      >
        <ListItem component='li' sx={{ marginBottom: 1 }} disablePadding>
          <ListItemIcon sx={{ minWidth: 'auto', paddingRight: 1 }}>
            <RefreshOutlinedIcon />
          </ListItemIcon>
          {t('serverError.guide.refreshPage')}
        </ListItem>
        <ListItem component='li' sx={{ marginBottom: 1 }} disablePadding>
          <ListItemIcon sx={{ minWidth: 'auto', paddingRight: 1 }}>
            <AccessTimeOutlinedIcon />
          </ListItemIcon>
          {t('serverError.guide.tryAgain')}
        </ListItem>
        <ListItem component='li' sx={{ marginBottom: 1 }} disablePadding>
          <ListItemIcon sx={{ minWidth: 'auto', paddingRight: 1 }}>
            <InfoOutlinedIcon />
          </ListItemIcon>
          {t('serverError.guide.contactCustomerService')}
        </ListItem>
      </List>
      <Button
        variant='outlined'
        onClick={refreshPage}
        sx={{
          paddingY: 1,
          paddingX: 2,
        }}
        startIcon={<RefreshOutlinedIcon />}
      >
        {t('serverError.loadPageAgain')}
      </Button>
    </Box>
  );
}
